import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Nav, Col } from 'react-bootstrap';
import './styles.css';
import { useDispatch } from 'react-redux';
import { atualizarPerfil } from '../../../store/modules/parceiro/actions';

function NavMobileToggler() {
  return <i className="fas fa-list nav-menu" />;
}

export default function NavbarMobile() {
  const fecharMenu = () => {
    const navbar = document.getElementsByClassName(
      'navbar-collapse collapse show'
    );
    navbar[0].classList.remove('show');
  };

  const dispatch = useDispatch();

  const atualizarVerTutorial = () => {
    const data = { verTutorial: true, nav: true };
    dispatch(atualizarPerfil(data));
  };

  return (
    <Navbar id="navbar" className="w-100" expand="xs">
      <Navbar.Toggle
        aria-controls="basic-navbar-nav"
        children={<NavMobileToggler />}
        className="w-auto mb-1"
      />
      <Col>
        <Link
          to="/loja"
          className="d-flex flex-column justify-content-center align-items-center"
        >
          <img
            style={{ width: '140px', marginLeft: '-30px' }}
            src="/imagens/logo-fundo-claro.png"
            alt="Logo Clube Pro Pintor"
          ></img>
        </Link>
      </Col>
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="mr-auto mt-4">
          <Nav.Item onClick={fecharMenu}>
            <Link className="nav-link" to="/loja">
              Home
            </Link>
          </Nav.Item>
          <Nav.Item onClick={fecharMenu}>
            <Link className="nav-link" to="/perfil">
              Meu Perfil
            </Link>
          </Nav.Item>
          <Nav.Item onClick={fecharMenu}>
            <Link className="nav-link" to="/pontuacoes">
              Pontuações
            </Link>
          </Nav.Item>
          <Nav.Item onClick={fecharMenu}>
            <Link className="nav-link" to="/resgates">
              Resgates
            </Link>
          </Nav.Item>
          <Nav.Item onClick={fecharMenu}>
            <Link className="nav-link" to="/treinamentos">
              Treinamentos
            </Link>
          </Nav.Item>
          <Nav.Item onClick={fecharMenu}>
            <Link className="nav-link" to="/cursos">
              Cursos
            </Link>
          </Nav.Item>
          <Nav.Item onClick={fecharMenu}>
            <Link className="nav-link" to="/ache-seu-pintor">
              Ache Seu Pintor
            </Link>
          </Nav.Item>{' '}
          <Nav.Item onClick={fecharMenu}>
            <Link className="nav-link" to="/cluster">
              Meu Nível
            </Link>
          </Nav.Item>
          {/* <Nav.Item onClick={fecharMenu}>
            <Link className="nav-link" to="/cartao">
              Cartão
            </Link>
          </Nav.Item> */}
          <Nav.Item onClick={fecharMenu}>
            <Link className="nav-link" to="/enviar-nf">
              Enviar Nota
            </Link>
          </Nav.Item>
          <Nav.Item onClick={fecharMenu}>
            <Link className="nav-link" to="/pontos-produtos">
              Pontos por Produto
            </Link>
          </Nav.Item>
          {/* <Nav.Item onClick={fecharMenu}>
            <Link className="nav-link" onClick={atualizarVerTutorial}>
              Tutorial
            </Link>
          </Nav.Item> */}
          <Nav.Item onClick={fecharMenu}>
            <Link className="nav-link" to="/regulamento">
              Regulamento Smart
            </Link>
          </Nav.Item>
          <Nav.Item onClick={fecharMenu}>
            <Link className="nav-link" to="/contato">
              Contato
            </Link>
          </Nav.Item>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
}
